import React from 'react';
import LoadingDots from './LoadingDots';
import ActionButton from './ActionButton';
import ButtonRow from './ButtonRow';
import TextBox from './TextBox';
import {getJson, postJson, resolveRoute} from '../helpers/ajax'
import * as kb from '../kb';
import RadioGroup from './RadioGroup';
import RadioButton from './RadioButton';
import ReactDOM from 'react-dom';
import Icon from './Icon';
import icons from '../../markons/markons';
import PubSub from 'pubsub-js';
import * as topics from '../pubsub-topics';

type State = any;

type Props = {
    chargeId: string;
    onCancel?: (...args: any[]) => any;
};

export default class StripeRefundForm extends React.PureComponent<Props, State> {

    amountInput: any;

    constructor(props: any) {
        super(props);
        this.state = {
            loading: false,
            saving: false,
            refund_type: '',
            refund_amount: '',
            captured: true,
        }
    }

    componentWillMount() {
        this.setState({loading: true});

        getJson(resolveRoute('api.stripeCharge', {chargeId: this.props.chargeId, requestType: 'refund'}))
            .then((res: any) => {
                if (res.ok) {
                    this.setState(res.data);
                    if (!res.data.captured) {
                        this.setState({refund_type: 'full'});
                    }
                }
            })
            .finally(() => {
                this.setState({loading: false});
            });
    }

    sendRefund = (ev: any) => {
        ev.preventDefault();
        this.setState({saving: true});

        postJson(resolveRoute('api.refundStripeCharge'), {
            chargeId: this.props.chargeId,
            amount: this.state.refund_type == 'partial' ? this.state.refund_amount : null,
            refund_type: this.state.refund_type,
        })
            .then((res: any) => {
                if (res.ok) {
                    if (res.data.error) {
                        kb.notify({
                            text: res.data.error,
                            className: 'error',
                        });
                    } else {
                        kb.notify({
                            text: `${kb.formatCurrency(res.data.amount)} refunded`,
                            className: 'success',
                        });
                        PubSub.publish(topics.PaymentEntered);
                        // @ts-expect-error ts-migrate(2339) FIXME: Property 'afterSave' does not exist on type 'Reado... Remove this comment to see the full error message
                        this.props.afterSave();
                    }
                } else {
                    kb.notify({
                        text: "Refund failed",
                        className: 'error',
                    });
                }
            })
            .finally(() => {
                this.setState({saving: false});
            });
    };

    typeChanged = (ev: any) => {
        this.setState({refund_type: ev.target.value});
    };

    amountChanged = (ev: any) => {
        this.setState({refund_amount: ev.target.value});
    };

    amountRef = (n: any) => {
        this.amountInput = n;
        // console.log(1,this.amountInput);
    };

    componentDidUpdate(prevProps: any, prevState: any) {
        if (this.state.refund_type === 'partial' && prevState.refund_type !== 'partial') {
            // console.log(2,this.amountInput);
            // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
            ReactDOM.findDOMNode(this.amountInput).focus();
            // this.amountInput.focus();
        }
    }

    render() {
        if (this.state.loading) {
            return <LoadingDots/>;
        }

        const fullAmount = this.state.amount - this.state.amount_refunded;


        return (
            <div className="grid-form">
                <div className="row">
                    <div className="col">
                        <RadioGroup onChange={this.typeChanged} value={this.state.refund_type}>
                            {/* @ts-expect-error ts-migrate(2322) FIXME: Property 'value' does not exist on type 'Intrinsic... Remove this comment to see the full error message */}
                            <RadioButton
                                value="full">{this.state.amount_refunded > 0 ? "Remaining Amount" : "Full Amount"} ({kb.formatCurrency(fullAmount)})</RadioButton>
                            {/* @ts-expect-error ts-migrate(2322) FIXME: Property 'value' does not exist on type 'Intrinsic... Remove this comment to see the full error message */}
                            <RadioButton value="partial"
                                         disabled={!this.state.captured}>Partial {this.state.captured ? "Refund" : "Release"}</RadioButton>
                        </RadioGroup>
                    </div>
                </div>

                {this.state.refund_type === 'partial' ? (
                    <div className="row">
                        <div className="col">
                            {/* @ts-expect-error ts-migrate(2769) FIXME: Property 'onChange' does not exist on type 'Intrin... Remove this comment to see the full error message */}
                            Refund Amount: $<TextBox onChange={this.amountChanged} value={this.state.refund_amount}
                                                     ref={this.amountRef} className="amount-input" placeholder="8.88"/>
                        </div>
                    </div>
                ) : null}

                <ButtonRow>
                    <ButtonRow.Left>
                        <ActionButton className="btn-save" onClick={this.sendRefund}
                                      disabled={this.state.saving || !this.state.refund_type}><Icon
                            name={icons.ionRefresh}/> {this.state.captured ? "Send Refund" : "Release Funds"}
                        </ActionButton>
                    </ButtonRow.Left>
                    <ButtonRow.Right>
                        <ActionButton className="btn-default" onClick={this.props.onCancel}><Icon
                            name="ion-backspace-outline"/> Cancel</ActionButton>
                    </ButtonRow.Right>
                </ButtonRow>
            </div>
        )
    }
}
